import React, { useState, useEffect } from "react";
import { Button } from "./ui/Button";
import { X, CheckCircle2 } from "lucide-react";
export function ExitPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !hasShown) {
        setIsOpen(true);
        setHasShown(true);
      }
    };
    document.addEventListener("mouseleave", handleMouseLeave);
    return () => document.removeEventListener("mouseleave", handleMouseLeave);
  }, [hasShown]);
  const handleApplyCoupon = () => {
    setCouponApplied(true);
    setTimeout(() => {
      setIsOpen(false);
    }, 1500);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0B1D70]/80 backdrop-blur-sm" data-id="element-83" data-mp="1x9cptncllb5v">
      <div className="bg-white rounded-[20px] w-full max-w-lg shadow-2xl relative overflow-hidden animate-in fade-in zoom-in duration-300 border-4 border-white/20" data-id="element-84" data-mp="1sa0270dwk028">
        <button onClick={() => setIsOpen(false)} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700 transition-colors z-10" data-id="element-85" data-mp="mwtd2vaptavx">
          <X className="w-5 h-5" data-id="element-86" data-mp="vobokswpv2io" />
        </button>

        <div className="bg-[#142FA8] p-6 text-center border-b border-white/10" data-id="element-87" data-mp="vr7najge1v86">
          <span className="inline-block bg-[#FFC900] text-[#07152D] text-[10px] md:text-xs font-[800] px-3 py-1.5 rounded-full uppercase tracking-wider mb-3" data-id="element-88" data-mp="3v6ctadkjboh3">
            OFERTA EXCLUSIVA PARA VOS
          </span>
          <h3 className="text-[24px] md:text-[30px] font-[900] text-white leading-[1.1] tracking-[-0.5px]" data-id="element-89" data-mp="8259jmovkmiy">
            ¡ESPERÁ! ACCEDÉ A MECÁNICO INDUSTRIAL PRO
          </h3>
        </div>

        <div className="p-6 md:p-8" data-id="element-90" data-mp="1jh1ykwl27bqb">
          <ul className="space-y-3 mb-8" data-id="element-91" data-mp="1odiy0mxplcip">
            {["Formación completa en video", "10 Bonos exclusivos incluidos", "Certificado de finalización", "Acceso de por vida"].map((item, idx) => <li key={idx} className="flex items-center gap-3 bg-[#F5F7F9] p-2.5 rounded-xl border border-gray-100" data-id="element-92" data-mp="3gflnhdzip2n2" data-mpi={idx}>
                <CheckCircle2 className="w-5 h-5 text-[#142FA8] flex-shrink-0" data-id="element-93" data-mp="3ufwfikckcn9t" />
                <span className="text-[#07152D] font-[600] text-[14px] md:text-[15px]" data-id="element-94" data-mp="3pg9zy499iuxu">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mb-8" data-id="element-95" data-mp="31rqvjztc32b1">
            <div className="inline-block bg-red-50 text-[#E90032] font-[800] px-3 py-1 rounded-full text-[12px] md:text-sm mb-2" data-id="element-96" data-mp="31omfa42lgg40">
              PRECIO NORMAL <span className="line-through" data-id="element-97" data-mp="3bgs81g0o71k9">$ 39.980 ARS</span>
            </div>
            <p className="text-[11px] md:text-xs font-[800] text-[#142FA8] uppercase tracking-wider mb-1" data-id="element-98" data-mp="36q23g502j2qm">CON CUPÓN DE DESCUENTO</p>
            <div className="text-[42px] md:text-[54px] font-[900] text-[#07152D] tracking-tighter leading-none transition-colors duration-300" data-id="element-99" data-mp="2iywpjvdoukiy">
              $ 19.990 <span className="text-[18px] md:text-[20px] font-[800] text-gray-400" data-id="element-100" data-mp="tj2jkehfj9dp">ARS</span>
            </div>
          </div>

          <div className="flex flex-col items-center" data-id="element-101" data-mp="ya2ddav95bbz">
            <Button size="xl" fullWidth className={`mb-3 transition-all duration-300 ${couponApplied ? 'bg-green-500 hover:bg-green-600 text-white border-green-600 shadow-[0_5px_15px_rgba(34,197,94,0.3)]' : ''}`} onClick={handleApplyCoupon} disabled={couponApplied} data-id="element-102" data-mp="ybn8p2pe4yaw">
              {couponApplied ? <>¡CUPÓN APLICADO! <CheckCircle2 className="ml-2 w-5 h-5" data-id="element-103" data-mp="1h6ajsi003s8v" /></> : <>APLICAR CUPÓN DE DESCUENTO <span className="ml-2 font-bold text-lg" data-id="element-104" data-mp="187ypo5zxecbo">→</span></>}
            </Button>
            <div className="flex items-center gap-2 text-[11px] md:text-xs font-[600] text-gray-500" data-id="element-105" data-mp="3nze51w7vgbcy">
              <span data-id="element-106" data-mp="3sxxuw7pl67al">Descuento especial</span>
              <span data-id="element-107" data-mp="3szsf1jt19vdm">•</span>
              <span data-id="element-108" data-mp="3svusspb5snpi">Solo por hoy</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}